import styled from "styled-components";
import Icon from "../../../../../../../../../base/icons/icon/index.js";
import { FlexMixin } from "../../../../../../../../../../styles/common/mixins/helpers.styled.js";
import panelErrorDesktopThemes from "./themes/index.js";
export const PanelError = styled.div.withConfig({
    displayName: "styled__PanelError",
    componentId: "sc-e7e26623-0"
})`
	${FlexMixin({
    align: 'center',
    justify: 'space-between'
})}
	background-color: ${({ theme  })=>theme.colors.primary.lightest};
	gap: 8px;

	${Icon} {
		margin-right: 8px;
		color: ${({ theme  })=>theme.colors.primary.light};
	}

	${({ theme  })=>panelErrorDesktopThemes[theme.id]?.PanelError?.()}
`;

//# sourceMappingURL=styled.js.map